import { createContext, useContext, useState } from 'react';

const SimulationContext = createContext();

export const SimulationProvider = ({ children }) => {
    const [isSimulation, setSimulation] = useState(false);
    const [isSimulationLoading, setSimulationLoading] = useState(true); 


    return (
        <SimulationContext.Provider value={{ 
            isSimulation, 
            setSimulation,
            isSimulationLoading,
            setSimulationLoading 
        }}>
            {children}
        </SimulationContext.Provider>
    );
};

export const useSimulation = () => useContext(SimulationContext);